import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useWizard } from 'react-use-wizard'
import { Button } from 'web/src/app/root/components/common'
import { useSelector } from 'react-redux'

/* eslint-disable */
const useStyles = makeStyles(theme => ({
    wrapper: {
        paddingRight: 20,
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '100%',
        maxWidth: '100%'
    },
    link: {
        color: theme.textPrimary,
        cursor: 'pointer',
        fontWeight: 'bold'
    },
    heading: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 'bold',
        fontSize: 30,
        textAlign: 'center',
        paddingBottom: 70
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        '& > *': {
            marginRight: '10px'
        }
    }
}))

export default function DeTerms({ acceptTs }) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const { previousStep, nextStep } = useWizard()
    return (
        <React.Fragment>
            <div className={classes.wrapper}>
                <h1 className={classes.heading}>Datenschutz­erklärung</h1>
                <h2>1. Datenschutz auf einen Blick</h2>
                <h3>Allgemeine Hinweise</h3>{' '}
                <p>
                    Die folgenden Hinweise geben einen einfachen Überblick
                    darüber, was mit Ihren personenbezogenen Daten passiert,
                    wenn Sie diese Website besuchen. Personenbezogene Daten sind
                    alle Daten, mit denen Sie persönlich identifiziert werden
                    können. Ausführliche Informationen zum Thema Datenschutz
                    entnehmen Sie unserer unter diesem Text aufgeführten
                    Datenschutzerklärung.
                </p>
                <h3>Datenerfassung auf dieser Website</h3>{' '}
                <h4>
                    Wer ist verantwortlich für die Datenerfassung auf dieser
                    Website?
                </h4>{' '}
                <p>
                    Die Datenverarbeitung auf dieser Website erfolgt durch den
                    Websitebetreiber. Dessen Kontaktdaten können Sie dem
                    Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser
                    Datenschutzerklärung entnehmen.
                </p>{' '}
                <h4>Wie erfassen wir Ihre Daten?</h4>{' '}
                <p>
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                    diese mitteilen. Hierbei kann es sich z. B. um Daten
                    handeln, die Sie in ein Kontaktformular eingeben.
                </p>{' '}
                <p>
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung
                    beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                    sind vor allem technische Daten (z. B. Internetbrowser,
                    Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
                    Erfassung dieser Daten erfolgt automatisch, sobald Sie diese
                    Website betreten.
                </p>{' '}
                <h4>Wofür nutzen wir Ihre Daten?</h4>{' '}
                <p>
                    Ein Teil der Daten wird erhoben, um eine fehlerfreie
                    Bereitstellung der Website zu gewährleisten. Andere Daten
                    können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                </p>{' '}
                <h4>Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>{' '}
                <p>
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                    Herkunft, Empfänger und Zweck Ihrer gespeicherten
                    personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                    Recht, die Berichtigung oder Löschung dieser Daten zu
                    verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung
                    erteilt haben, können Sie diese Einwilligung jederzeit für
                    die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                    bestimmten Umständen die Einschränkung der Verarbeitung
                    Ihrer personenbezogenen Daten zu verlangen. Des Weiteren
                    steht Ihnen ein Beschwerderecht bei der zuständigen
                    Aufsichtsbehörde zu.
                </p>{' '}
                <p>
                    Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können
                    Sie sich jederzeit an uns wenden.
                </p>
                <h2>2. Allgemeine Hinweise und Pflicht­informationen</h2>
                <h3>Datenschutz</h3>{' '}
                <p>
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                    persönlichen Daten sehr ernst. Wir behandeln Ihre
                    personenbezogenen Daten vertraulich und entsprechend der
                    gesetzlichen Datenschutzvorschriften sowie dieser
                    Datenschutzerklärung.
                </p>{' '}
                <p>
                    Wenn Sie diese Website benutzen, werden verschiedene
                    personenbezogene Daten erhoben. Personenbezogene Daten sind
                    Daten, mit denen Sie persönlich identifiziert werden können.
                    Die vorliegende Datenschutzerklärung erläutert, welche Daten
                    wir erheben und wofür wir sie nutzen. Sie erläutert auch,
                    wie und zu welchem Zweck das geschieht.
                </p>{' '}
                <p>
                    Wir weisen darauf hin, dass die Datenübertragung im Internet
                    (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken
                    aufweisen kann. Ein lückenloser Schutz der Daten vor dem
                    Zugriff durch Dritte ist nicht möglich.
                </p>
                <h3>Hinweis zur verantwortlichen Stelle</h3>{' '}
                <p>
                    Die verantwortliche Stelle für die Datenverarbeitung auf
                    dieser Website ist:
                </p>{' '}
                <p>
                    traplinked GmbH
                    <br />
                    Zollhof 7<br />
                    90443 Nürnberg
                </p>
                <p>
                    Telefon: +49 911 47712850
                    <br />
                    E-Mail: kontakt@traplinked.com
                </p>
                <p>
                    Verantwortliche Stelle ist die natürliche oder juristische
                    Person, die allein oder gemeinsam mit anderen über die
                    Zwecke und Mittel der Verarbeitung von personenbezogenen
                    Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                </p>
                <h3>Speicherdauer</h3>{' '}
                <p>
                    Soweit innerhalb dieser Datenschutzerklärung keine
                    speziellere Speicherdauer genannt wurde, verbleiben Ihre
                    personenbezogenen Daten bei uns, bis der Zweck für die
                    Datenverarbeitung entfällt. Wenn Sie ein berechtigtes
                    Löschersuchen geltend machen oder eine Einwilligung zur
                    Datenverarbeitung widerrufen, werden Ihre Daten gelöscht,
                    sofern wir keinen anderen rechtlich zulässigen  Gründe für
                    die Speicherung Ihrer personenbezogenen Daten haben (z.B.
                    steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                    letztgenannten Fall erfolgt die Löschung nach Fortfall
                    dieser Gründe.
                </p>
                <h3>Hinweis zur Datenweitergabe in die USA</h3>{' '}
                <p>
                    Auf unserer Website sind unter anderem Tools von Unternehmen
                    mit Sitz in den USA eingebunden. Wenn diese Tools aktiv
                    sind, können Ihre personenbezogenen Daten an die US-Server
                    der jeweiligen Unternehmen weitergegeben werden. Wir weisen
                    darauf hin, dass die USA kein sicherer Drittstaat im Sinne
                    des EU-Datenschutzrechts sind. US-Unternehmen sind dazu
                    verpflichtet, personenbezogene Daten an Sicherheitsbehörden
                    herauszugeben, ohne dass Sie als Betroffener hiergegen
                    gerichtlich vorgehen könnten. Es kann daher nicht
                    ausgeschlossen werden, dass US-Behörden (z.B. Geheimdienste)
                    Ihre auf US-Servern befindlichen Daten zu
                    Überwachungszwecken verarbeiten, auswerten und dauerhaft
                    speichern. Wir haben auf diese Verarbeitungstätigkeiten
                    keinen Einfluss.
                </p>
                <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>{' '}
                <p>
                    Viele Datenverarbeitungsvorgänge sind nur mit Ihrer
                    ausdrücklichen Einwilligung möglich. Sie können eine bereits
                    erteilte Einwilligung jederzeit widerrufen. Die
                    Rechtmäßigkeit der bis zum Widerruf erfolgten
                    Datenverarbeitung bleibt vom Widerruf unberührt.
                </p>
                <h3>
                    Widerspruchsrecht gegen die Datenerhebung in besonderen
                    Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
                </h3>{' '}
                <p>
                    WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1
                    LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT,
                    AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION
                    ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN
                    DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF
                    DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE
                    RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
                    ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE
                    WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN
                    PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN,
                    WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE
                    VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND
                    FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER
                    GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON
                    RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
                </p>{' '}
                <p>
                    WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM
                    DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT,
                    JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE
                    BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER
                    WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT
                    ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
                    WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN
                    ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG
                    VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
                </p>
                <h3>Beschwerde­recht bei der zuständigen Aufsichts­behörde</h3>{' '}
                <p>
                    Im Falle von Verstößen gegen die DSGVO steht den Betroffenen
                    ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere
                    in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres
                    Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu.
                    Das Beschwerderecht besteht unbeschadet anderweitiger
                    verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                </p>
                <h3>Recht auf Daten­übertrag­barkeit</h3>{' '}
                <p>
                    Sie haben das Recht, Daten, die wir auf Grundlage Ihrer
                    Einwilligung oder in Erfüllung eines Vertrags automatisiert
                    verarbeiten, an sich oder an einen Dritten in einem
                    gängigen, maschinenlesbaren Format aushändigen zu lassen.
                    Sofern Sie die direkte Übertragung der Daten an einen
                    anderen Verantwortlichen verlangen, erfolgt dies nur, soweit
                    es technisch machbar ist.
                </p>
                <h3>SSL- bzw. TLS-Verschlüsselung</h3>{' '}
                <p>
                    Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                    Übertragung vertraulicher Inhalte, wie zum Beispiel
                    Bestellungen oder Anfragen, die Sie an uns als
                    Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
                    Eine verschlüsselte Verbindung erkennen Sie daran, dass die
                    Adresszeile des Browsers von „http://“ auf „https://“
                    wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>{' '}
                <p>
                    Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können
                    die Daten, die Sie an uns übermitteln, nicht von Dritten
                    mitgelesen werden.
                </p>
                <h3>Auskunft, Löschung und Berichtigung</h3>{' '}
                <p>
                    Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
                    jederzeit das Recht auf unentgeltliche Auskunft über Ihre
                    gespeicherten personenbezogenen Daten, deren Herkunft und
                    Empfänger und den Zweck der Datenverarbeitung und ggf. ein
                    Recht auf Berichtigung oder Löschung dieser Daten. Hierzu
                    sowie zu weiteren Fragen zum Thema personenbezogene Daten
                    können Sie sich jederzeit an uns wenden.
                </p>
                <h3>Recht auf Einschränkung der Verarbeitung</h3>{' '}
                <p>
                    Sie haben das Recht, die Einschränkung der Verarbeitung
                    Ihrer personenbezogenen Daten zu verlangen. Hierzu können
                    Sie sich jederzeit an uns wenden. Das Recht auf
                    Einschränkung der Verarbeitung besteht in folgenden Fällen:
                </p>{' '}
                <ul>
                    {' '}
                    <li>
                        Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
                        personenbezogenen Daten bestreiten, benötigen wir in der
                        Regel Zeit, um dies zu überprüfen. Für die Dauer der
                        Prüfung haben Sie das Recht, die Einschränkung der
                        Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                    </li>{' '}
                    <li>
                        Wenn die Verarbeitung Ihrer personenbezogenen Daten
                        unrechtmäßig geschah/geschieht, können Sie statt der
                        Löschung die Einschränkung der Datenverarbeitung
                        verlangen.
                    </li>{' '}
                    <li>
                        Wenn wir Ihre personenbezogenen Daten nicht mehr
                        benötigen, Sie sie jedoch zur Ausübung, Verteidigung
                        oder Geltendmachung von Rechtsansprüchen benötigen,
                        haben Sie das Recht, statt der Löschung die
                        Einschränkung der Verarbeitung Ihrer personenbezogenen
                        Daten zu verlangen.
                    </li>{' '}
                    <li>
                        Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO
                        eingelegt haben, muss eine Abwägung zwischen Ihren und
                        unseren Interessen vorgenommen werden. Solange noch
                        nicht feststeht, wessen Interessen überwiegen, haben Sie
                        das Recht, die Einschränkung der Verarbeitung Ihrer
                        personenbezogenen Daten zu verlangen.
                    </li>{' '}
                </ul>{' '}
                <p>
                    Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
                    eingeschränkt haben, dürfen diese Daten – von ihrer
                    Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur
                    Geltendmachung, Ausübung oder Verteidigung von
                    Rechtsansprüchen oder zum Schutz der Rechte einer anderen
                    natürlichen oder juristischen Person oder aus Gründen eines
                    wichtigen öffentlichen Interesses der Europäischen Union
                    oder eines Mitgliedstaats verarbeitet werden.
                </p>
                <h2>3. Datenerfassung auf dieser Website</h2>
                <h3>Cookies</h3>{' '}
                <p>
                    Unsere Internetseiten verwenden so genannte „Cookies“.
                    Cookies sind kleine Textdateien und richten auf Ihrem
                    Endgerät keinen Schaden an. Sie werden entweder
                    vorübergehend für die Dauer einer Sitzung (Session-Cookies)
                    oder dauerhaft (permanente Cookies) auf Ihrem Endgerät
                    gespeichert. Session-Cookies werden nach Ende Ihres Besuchs
                    automatisch gelöscht. Permanente Cookies bleiben auf Ihrem
                    Endgerät gespeichert, bis Sie diese selbst löschen oder eine
                    automatische Löschung durch Ihren Webbrowser erfolgt.
                </p>{' '}
                <p>
                    Teilweise können auch Cookies von Drittunternehmen auf Ihrem
                    Endgerät gespeichert werden, wenn Sie unsere Seite betreten
                    (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die
                    Nutzung bestimmter Dienstleistungen des Drittunternehmens
                    (z.B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
                </p>{' '}
                <p>
                    Cookies haben verschiedene Funktionen. Zahlreiche Cookies
                    sind technisch notwendig, da bestimmte Websitefunktionen
                    ohne diese nicht funktionieren würden (z.B. die
                    Warenkorbfunktion oder die Anzeige von Videos). Andere
                    Cookies dienen dazu, das Nutzerverhalten auszuwerten oder
                    Werbung anzuzeigen.
                </p>{' '}
                <p>
                    Cookies, die zur Durchführung des elektronischen
                    Kommunikationsvorgangs (notwendige Cookies) oder zur
                    Bereitstellung bestimmter, von Ihnen erwünschter Funktionen
                    (funktionale Cookies, z. B. für die Warenkorbfunktion) oder
                    zur Optimierung der Website (z.B. Cookies zur Messung des
                    Webpublikums) erforderlich sind, werden auf Grundlage von
                    Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere
                    Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein
                    berechtigtes Interesse an der Speicherung von Cookies zur
                    technisch fehlerfreien und optimierten Bereitstellung seiner
                    Dienste. Sofern eine Einwilligung zur Speicherung von
                    Cookies abgefragt wurde, erfolgt die Speicherung der
                    betreffenden Cookies ausschließlich auf Grundlage dieser
                    Einwilligung (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung
                    ist jederzeit widerrufbar.
                </p>{' '}
                <p>
                    Sie können Ihren Browser so einstellen, dass Sie über das
                    Setzen von Cookies informiert werden und Cookies nur im
                    Einzelfall erlauben, die Annahme von Cookies für bestimmte
                    Fälle oder generell ausschließen sowie das automatische
                    Löschen der Cookies beim Schließen des Browsers aktivieren.
                    Bei der Deaktivierung von Cookies kann die Funktionalität
                    dieser Website eingeschränkt sein.
                </p>{' '}
                <p>
                    Soweit Cookies von Drittunternehmen oder zu Analysezwecken
                    eingesetzt werden, werden wir Sie hierüber im Rahmen dieser
                    Datenschutzerklärung gesondert informieren und ggf. eine
                    Einwilligung abfragen.
                </p>
                <h3>Server-Log-Dateien</h3>{' '}
                <p>
                    Der Provider der Seiten erhebt und speichert automatisch
                    Informationen in so genannten Server-Log-Dateien, die Ihr
                    Browser automatisch an uns übermittelt. Dies sind:
                </p>{' '}
                <ul>
                    {' '}
                    <li>Browsertyp und Browserversion</li>{' '}
                    <li>verwendetes Betriebssystem</li> <li>Referrer URL</li>{' '}
                    <li>Hostname des zugreifenden Rechners</li>{' '}
                    <li>Uhrzeit der Serveranfrage</li> <li>IP-Adresse</li>{' '}
                </ul>{' '}
                <p>
                    Eine Zusammenführung dieser Daten mit anderen Datenquellen
                    wird nicht vorgenommen.
                </p>{' '}
                <p>
                    Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6
                    Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein
                    berechtigtes Interesse an der technisch fehlerfreien
                    Darstellung und der Optimierung seiner Website – hierzu
                    müssen die Server-Log-Files erfasst werden.
                </p>
                <h3>Kontaktformular</h3>{' '}
                <p>
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                    werden Ihre Angaben aus dem Anfrageformular inklusive der
                    von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
                    der Anfrage und für den Fall von Anschlussfragen bei uns
                    gespeichert. Diese Daten geben wir nicht ohne Ihre
                    Einwilligung weiter.
                </p>{' '}
                <p>
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art.
                    6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung
                    eines Vertrags zusammenhängt oder zur Durchführung
                    vorvertraglicher Maßnahmen erforderlich ist. In allen
                    übrigen Fällen beruht die Verarbeitung auf unserem
                    berechtigten Interesse an der effektiven Bearbeitung der an
                    uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder
                    auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern
                    diese abgefragt wurde.
                </p>{' '}
                <p>
                    Die von Ihnen im Kontaktformular eingegebenen Daten
                    verbleiben bei uns, bis Sie uns zur Löschung auffordern,
                    Ihre Einwilligung zur Speicherung widerrufen oder der Zweck
                    für die Datenspeicherung entfällt (z. B. nach
                    abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende
                    gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen
                    – bleiben unberührt.
                </p>
                <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>{' '}
                <p>
                    Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren,
                    wird Ihre Anfrage inklusive aller daraus hervorgehenden
                    personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                    Bearbeitung Ihres Anliegens bei uns gespeichert und
                    verarbeitet. Diese Daten geben wir nicht ohne Ihre
                    Einwilligung weiter.
                </p>{' '}
                <p>
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art.
                    6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung
                    eines Vertrags zusammenhängt oder zur Durchführung
                    vorvertraglicher Maßnahmen erforderlich ist. In allen
                    übrigen Fällen beruht die Verarbeitung auf unserem
                    berechtigten Interesse an der effektiven Bearbeitung der an
                    uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder
                    auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern
                    diese abgefragt wurde.
                </p>{' '}
                <p>
                    Die von Ihnen an uns per Kontaktanfragen übersandten Daten
                    verbleiben bei uns, bis Sie uns zur Löschung auffordern,
                    Ihre Einwilligung zur Speicherung widerrufen oder der Zweck
                    für die Datenspeicherung entfällt (z. B. nach
                    abgeschlossener Bearbeitung Ihres Anliegens). Zwingende
                    gesetzliche Bestimmungen – insbesondere gesetzliche
                    Aufbewahrungsfristen – bleiben unberührt.
                </p>
                <h3>Registrierung auf dieser Website</h3>{' '}
                <p>
                    Sie können sich auf dieser Website registrieren, um
                    zusätzliche Funktionen auf der Seite zu nutzen. Die dazu
                    eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung
                    des jeweiligen Angebotes oder Dienstes, für den Sie sich
                    registriert haben. Die bei der Registrierung abgefragten
                    Pflichtangaben müssen vollständig angegeben werden.
                    Anderenfalls werden wir die Registrierung ablehnen.
                </p>{' '}
                <p>
                    Für wichtige Änderungen etwa beim Angebotsumfang oder bei
                    technisch notwendigen Änderungen nutzen wir die bei der
                    Registrierung angegebene E-Mail-Adresse, um Sie auf diesem
                    Wege zu informieren.
                </p>{' '}
                <p>
                    Die Verarbeitung der bei der Registrierung eingegebenen
                    Daten erfolgt zum Zwecke der Durchführung des durch die
                    Registrierung begründeten Nutzungsverhältnisses und ggf. zur
                    Anbahnung weiterer Verträge (Art. 6 Abs. 1 lit. b DSGVO).
                </p>{' '}
                <p>
                    Die bei der Registrierung erfassten Daten werden von uns
                    gespeichert, solange Sie auf dieser Website registriert sind
                    und werden anschließend gelöscht. Gesetzliche
                    Aufbewahrungsfristen bleiben unberührt.
                </p>
                <h3>YouTube</h3>
                <p>1. Umfang der Verarbeitung personenbezogener Daten</p>
                <p>
                    Wir nutzen das von Google betriebene Plugin von YouTube, der
                    YouTube LLC, 901 Cherry Ave., San Bruno, CA 94066, USA und
                    deren Vertreter in der Union Google Ireland Limited, Gordon
                    House, Barrow Street, Dublin 4, Irland (Nachfolgend: Google
                    genannt). Wir nutzen das Plugin von YouTube um Videos von
                    YouTube auf unserer Onlinepräsenz einzubetten. Beim Besuch
                    unserer Onlinepräsenz stellt Ihr Browser eine Verbindung mit
                    den Servern von YouTube her. Es können dadurch
                    personenbezogene Daten gespeichert und ausgewertet werden,
                    vor allem die Aktivität des Nutzers (Insbesondere welche
                    Seiten besucht worden sind und auf welche Elemente geklickt
                    worden ist) sowie Geräte- und Browserinformationen
                    (Insbesondere die IP-Adresse und das Betriebssystem).
                    <br />
                    Wir haben keinen Einfluss auf den Inhalt des Plug-Ins.
                    Sofern Sie während des Besuchs in Ihrem YouTube-Account
                    eingeloggt sind, kann YouTube Ihren Onlinepräsenzenbesuch
                    diesem Konto zuordnen. Durch Interaktion mit diesem Plug-In
                    werden diese entsprechenden Informationen direkt an YouTube
                    übermittelt und dort gespeichert.
                    <br />
                    Weitere Informationen zur Verarbeitung der Daten durch
                    Google erhalten Sie hier:
                    <br />
                    <a
                        href="https://policies.google.com/privacy?gl=DE&amp;hl=de"
                        target="_blank"
                        rel="noopener">
                        https://policies.google.com/privacy?gl=DE&amp;hl=de
                    </a>
                </p>
                <p>2. Zweck der Datenverarbeitung</p>
                <p>
                    Die Verwendung des YouTube-PlugIns dient der Verbesserung
                    der Nutzerfreundlichkeit und einer ansprechenden Darstellung
                    unserer Onlinepräsenz.
                </p>
                <p>
                    3. Rechtsgrundlage für die Verarbeitung personenbezogener
                    Daten
                </p>
                <p>
                    Rechtsgrundlage für die Verarbeitung der personenbezogenen
                    Daten der Nutzer ist grundsätzlich die Einwilligung des
                    Nutzers nach Art. 6 Abs. 1 S.1 lit. a DSGVO.
                </p>
                <p>4. Dauer der Speicherung</p>
                <p>
                    Ihre persönlichen Informationen werden solange gespeichert,
                    wie dies erforderlich ist, um die in dieser
                    Datenschutzerklärung beschriebenen Zwecke zu erfüllen oder
                    wie dies gesetzlich vorgeschrieben ist, z.B. für Steuer- und
                    Buchhaltungszwecke.
                </p>
                <p>5. Widerrufs- und Beseitigungsmöglichkeit</p>
                <p>
                    Sie haben das Recht, Ihre datenschutzrechtliche
                    Einwilligungserklärung jederzeit zu widerrufen. Durch den
                    Widerruf der Einwilligung wird die Rechtmäßigkeit, der
                    aufgrund der Einwilligung bis zum Widerruf erfolgten
                    Verarbeitung nicht berührt.
                    <br />
                    Sie können die Erfassung sowie die Verarbeitung Ihrer
                    personenbezogenen Daten durch Google verhindern, indem Sie
                    die Speicherung von Cookies von Drittanbietern auf Ihrem
                    Computer unterbinden, die "Do Not Track"-Funktion eines
                    unterstützenden Browsers nutzen, die Ausführung von
                    Script-Code in Ihrem Browser deaktivieren oder einen
                    Script-Blocker wie z.B. NoScript (
                    <a
                        href="https://noscript.net/"
                        target="_blank"
                        rel="noopener">
                        https://noscript.net/
                    </a>
                    ) oder Ghostery (
                    <a
                        href="https://www.ghostery.com"
                        target="_blank"
                        rel="noopener">
                        https://www.ghostery.com
                    </a>
                    ) in Ihrem Browser installieren.
                    <br />
                    Mit dem nachfolgenden Link können Sie die Nutzung Ihrer
                    personenbezogenen Daten durch Google deaktivieren:
                    <br />
                    <a
                        href="https://adssettings.google.de/anonymous?hl=de"
                        target="_blank"
                        rel="noopener">
                        https://adssettings.google.de
                    </a>
                    <br />
                    Weitere Informationen zu Widerspruchs- und
                    Beseitigungsmöglichkeiten gegenüber Google finden Sie unter:
                    <br />
                    <a
                        href="https://policies.google.com/privacy?gl=DE&amp;hl=de"
                        target="_blank"
                        rel="noopener">
                        https://policies.google.com/privacy?gl=DE&amp;hl=de
                    </a>
                </p>
                <h2>4. Plugins und Tools</h2>
                <h3>Google Web Fonts</h3>{' '}
                <p>
                    Diese Seite nutzt zur einheitlichen Darstellung von
                    Schriftarten so genannte Web Fonts, die von Google
                    bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr
                    Browser die benötigten Web Fonts in ihren Browsercache, um
                    Texte und Schriftarten korrekt anzuzeigen.
                </p>{' '}
                <p>
                    Zu diesem Zweck muss der von Ihnen verwendete Browser
                    Verbindung zu den Servern von Google aufnehmen. Hierdurch
                    erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse
                    diese Website aufgerufen wurde. Die Nutzung von Google
                    WebFonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
                    DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse
                    an der einheitlichen Darstellung des Schriftbildes auf
                    seiner Website. Sofern eine entsprechende Einwilligung
                    abgefragt wurde (z. B. eine Einwilligung zur Speicherung von
                    Cookies), erfolgt die Verarbeitung ausschließlich auf
                    Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung
                    ist jederzeit widerrufbar.
                </p>{' '}
                <p>
                    Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine
                    Standardschrift von Ihrem Computer genutzt.
                </p>{' '}
                <p>
                    Weitere Informationen zu Google Web Fonts finden Sie unter{' '}
                    <a
                        href="https://developers.google.com/fonts/faq"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://developers.google.com/fonts/faq
                    </a>{' '}
                    und in der Datenschutzerklärung von Google:{' '}
                    <a
                        href="https://policies.google.com/privacy?hl=de"
                        target="_blank"
                        rel="noopener noreferrer">
                        https://policies.google.com/privacy?hl=de
                    </a>
                    .
                </p>
            </div>
            <div className={classes.buttonContainer}>
                <Button reverted onClick={previousStep}>
                    {locale.userManagement.stepBack}
                </Button>
                <Button onClick={acceptTs}>{locale.common.acceptTerms}</Button>
            </div>
        </React.Fragment>
    )
}
/* eslint-enable */
